import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"
import { convertDotToCommaZero } from "../../../app/helpers/TextHelper.js"
export const CvlTable = ({ data }) => {
  const rows = 8
  const { t } = useTranslation()

  const getValue = (index) => data?.cvl[index] ?? "-"

  return (
    <table className="w-full border border-secondary bg-gray mb-10 font-size-lg">
      <thead className={"border-secondary text-wrap"}>
        <tr>
          <th className={"border h-cvl"} colSpan={"8"}>
            <div className={"mr-2 font-weight-bold"}>
              <strong>{t("label_example_point")}:</strong>{" "}
              {data?.total_point ? data?.total_point : "-"}
            </div>
          </th>
          <th className={"border h-cvl"} colSpan={"8"}>
            <div className={"mr-2 font-weight-bold"}>
              <strong>{t("label_example_point")}:</strong> 100{" "}
              <span className="font-weight-bold">{t("label_plant_family")}</span>
            </div>
          </th>
        </tr>
      </thead>
      <thead className={"text-center"}>
        <tr>
          {[...Array(rows)].map((_, i) => (
            <Fragment key={i}>
              <th className="bg-secondary border px-2 py-1 size-cvl-small">No.</th>
              <th className="bg-secondary border px-2 size-cvl-medium">CVL/TS</th>
            </Fragment>
          ))}
        </tr>
        <tr>
          {[...Array(rows)].map((_, i) => (
            <Fragment key={i}>
              <th className="bg-light border px-2 py-1 font-weight-bold size-cvl-small">
                {i * 2 + 1}.
              </th>
              <th className=" border px-2 py-1 font-weight-bolder size-cvl-medium">
                {getValue(i * 2)}
              </th>
            </Fragment>
          ))}
        </tr>
      </thead>
      <tbody className={"text-center"}>
        <tr>
          {[...Array(rows)].map((_, i) => (
            <Fragment key={i}>
              <td className="bg-light border px-2 py-1 font-weight-bold size-cvl-small">
                {i * 2 + 2}.
              </td>
              <td className="border px-2 py-1 font-weight-bolder size-cvl-medium">
                {getValue(i * 2 + 1)}
              </td>
            </Fragment>
          ))}
        </tr>
      </tbody>
      <thead className={"text-wrap"}>
        <tr>
          <th className={"border h-cvl"} colSpan={"16"}>
            <div className="mr-2 font-weight-bold">{`Rata - rata: ${convertDotToCommaZero(
              data?.average,
              "%"
            )}`}</div>
          </th>
        </tr>
      </thead>
    </table>
  )
}
